// Centralized contact info — change here once and it propagates across the site.
export const CONTACT = {
  brand: "Master Credit Group",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_credit-fix-hub-1/artifacts/n1u4vxbb_WhatsApp%20Image%202026-05-02%20at%2010.36.10%20AM.jpeg",
  logoIconUrl:
    "https://customer-assets.emergentagent.com/job_credit-fix-hub-1/artifacts/0ywya9uf_WhatsApp%20Image%202026-05-27%20at%2012.41.46%20PM.jpeg",
  phoneDisplay: "(346) 589-7005",
  phoneE164: "+13465897005",
  phoneDisplay2: "(832) 756-0573",
  phoneE164_2: "+18327560573",
  whatsappNumber: "18327560573", // for wa.me URL (no '+')
  whatsappPrefilledMessage:
    "Hola, me interesa una consulta gratuita con Master Credit Group.",
  email: "mastercreditgroup@gmail.com",
  city: "Houston, TX",
  country: "Estados Unidos",
  addressLine1: "10910 Jones Rd, Ste 2B",
  addressLine2: "Houston, TX 77065, USA",
  addressFull: "10910 Jones Rd, Ste 2B, Houston, TX 77065, USA",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=10910+Jones+Rd+Ste+2B+Houston+TX+77065",
  social: {
    instagram: "https://www.instagram.com/mastercreditgroup",
    facebook: "https://www.facebook.com/mastercreditgroup",
    tiktok: "https://www.tiktok.com/@mastercreditgroup",
  },
};

export const telHref = `tel:${CONTACT.phoneE164}`;
export const telHref2 = `tel:${CONTACT.phoneE164_2}`;
export const mailtoHref = `mailto:${CONTACT.email}`;
export const whatsappHref = `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(
  CONTACT.whatsappPrefilledMessage
)}`;
